import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import './auth.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

function LoginPage() {
  const { login, loginConToken } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errore, setErrore] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (token) {
      loginConToken(token);
      navigate('/');
    }
  }, [params, loginConToken, navigate]);

  async function onSubmit(e) {
    e.preventDefault();
    setErrore('');
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setErrore((err.response && err.response.data && err.response.data.error) || t('login.errore'));
    }
  }

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={onSubmit}>
        <h1>{t('login.titolo')}</h1>
        {errore && <p className="auth-error" role="alert">{errore}</p>}
        <label>
          {t('login.email')}
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label>
          {t('login.password')}
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        <button type="submit" className="auth-submit">{t('login.submit')}</button>
        <a className="auth-google" href={`${API_URL}/auth/google`}>
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
            <path fill="none" d="M0 0h48v48H0z"/>
          </svg>
          {t('login.google')}
        </a>
        <p className="auth-switch">
          {t('login.noAccount')} <Link to="/register">{t('nav.registrati')}</Link>
        </p>
      </form>
    </div>
  );
}

export default LoginPage;
